<div
  class="message-attachment"
  [class.message-attachment--unavailable]="!!unavailableReason"
  [class.message-attachment--processing]="isProcessing"
>
  <div
    class="message-attachment__icon-wrapper"
    [ngClass]="'message-attachment__icon-wrapper--' + attachmentType"
    [ngSwitch]="attachmentType"
  >
    <ng-container *ngSwitchCase="EnumAttachmentType.PDF">
      <i class="far fa-file-pdf message-attachment__icon message-attachment__icon--pdf"></i>
    </ng-container>

    <ng-container *ngSwitchCase="EnumAttachmentType.EXCEL">
      <i class="far fa-file-excel message-attachment__icon message-attachment__icon--excel"></i>
    </ng-container>

    <ng-container *ngSwitchCase="EnumAttachmentType.POWERPOINT">
      <i class="far fa-file-powerpoint message-attachment__icon message-attachment__icon--powerpoint"></i>
    </ng-container>

    <ng-container *ngSwitchCase="EnumAttachmentType.WORD">
      <i class="far fa-file-word message-attachment__icon message-attachment__icon--word"></i>
    </ng-container>

    <ng-container *ngSwitchCase="EnumAttachmentType.IMAGE">
      <i class="far fa-file-image message-attachment__icon message-attachment__icon--image"></i>
    </ng-container>

    <ng-container *ngSwitchCase="EnumAttachmentType.TEXT">
      <i class="far fa-file-alt message-attachment__icon message-attachment__icon--text"></i>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <i class="far fa-file message-attachment__icon"></i>
    </ng-container>
  </div>

  <span class="message-attachment__text">
    <span class="message-attachment__name" [title]="attachment.name">
      {{ attachment.name }}
    </span>
    <span class="message-attachment__origin" *ngIf="origin && canDownload">{{ origin }}</span>
    <span class="message-attachment__processing" *ngIf="isProcessing">
      <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
      Processando…
    </span>
    <span class="message-attachment__unavailable" *ngIf="unavailableReason">
      {{ unavailableReason }}
    </span>
  </span>

  <div class="message-attachment__actions" *ngIf="canDownload">
    <button
      type="button"
      class="message-attachment__btn"
      sgtTooltip="Baixar arquivo"
      [disabled]="isLoading"
      (click)="onDownload()"
    >
      <i class="fas" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-download'"></i>
    </button>
  </div>
</div>
